import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ApartmentOutlinedSvg from "@ant-design/icons-svg/es/asn/ApartmentOutlined";
import AntdIcon from "../components/AntdIcon";
var ApartmentOutlined = function ApartmentOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ApartmentOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ApartmentOutlined.displayName = 'ApartmentOutlined';
}
export default /*#__PURE__*/React.forwardRef(ApartmentOutlined);